<style>
    .btn-icon .icon-container {
        position: relative;
    }

    .btn-icon .main-icon {
        display: block;
    }

    .btn-icon .download-icon {
        position: absolute;
        bottom: -5px;
        right: 3px;
        font-size: larger;
    }

    :global(.leaflet-control-layers-toggle) {
		background-image: url('./assets/images/layers.png');
	}
</style>
<script lang="ts">
    import Button, { Label } from '@smui/button';
    import LinearProgress from '@smui/linear-progress';
    import Card from '@smui/card';
    import FormField from '@smui/form-field';
    import Radio from '@smui/radio';
    import Input from '@smui/textfield';
    import { _ } from 'svelte-i18n';
    import StepWizard from 'svelte-step-wizard';
    import Title from '../../../..//shared/components/common/Title.svelte';
    import TableLoading from '../../../../shared/components/common/Loading/TableLoading.svelte';
    import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
    import FiltroGenerico from '../../../../shared/models/Filtri/FiltroGenerico';
    import PSCLElaborazione from '../../../../shared/models/PSCL/Elaborazione/PSCLElaborazione';
    import Query from '../../../../shared/models/Query/Query';
    import Sede from '../../../../shared/models/Sede/Sede';
    import QueryReportsContainer from './components/QueryReports/QueryReportsContainer.svelte';
    import QuerySedeList from './components/QuerySedeList.svelte';
    import QuerySedeMap from './components/QuerySedeMap.svelte';
	import { writable } from 'svelte/store';

	export let params = {
		id: '0',
	};

    let [data, loading, error] = Query.get(params.id);

    let filters: FiltroGenerico = {
        indirizzoOK: false,
		nomeAziendaEnte: ''
	};

	$: [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getListWithSedi(filters);

    $: disabled = !isAnySedeSelected || $data?.descrizione === '';
    
    $: isAnySedeSelected = sediSelected?.length > 0;

    $: sediSelected = $dataAziendeEnti?.response?.reduce((acc, aziendaEnte) => {
			const sedi = aziendaEnte?.sedi?.filter(sede => sede.selected === true);
			return [...acc, ...sedi];
		}, []);

    let tableVisualization = true;

    let initialSelectionDone = false;

    let [psclExportResponse, psclExportLoading, psclExportError] = [null, writable(false), null];

    async function handlePSCLExport() {
        [psclExportResponse, psclExportLoading, psclExportError] = await PSCLElaborazione.export({
            sediId: sediSelected.map(sede => sede.id)
        });
    }


    $: if (!initialSelectionDone && $dataAziendeEnti?.response?.length > 0 && $data?.sedi?.length > 0) {
        $dataAziendeEnti.response.forEach(aziendaEnte => {
            aziendaEnte.sedi.forEach(sede => {
                if ($data.sedi.some(sedeDaSelezionare => sedeDaSelezionare.id === sede.id)) {
                    sede.selected = true;
                }
            });
        });
        $dataAziendeEnti.response = [...$dataAziendeEnti.response];
        initialSelectionDone = true;
    }
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.query.detail.title')}" />
	</div>
    <StepWizard initialStep="{1}">
        <StepWizard.Step num="{1}" let:nextStep>
            <div class="grid grid-cols-1 px-4 pt-4">
                <div class="flex col-start-2" style="text-align: end">
                    <button disabled={$data?.descrizione === ''} type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep()}">
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
                    </button>
                </div>
            </div>
            <Input
                label="{$_('page.query.detail.description')}"
                bind:value="{$data.descrizione}"
                required
            />
        </StepWizard.Step>
        <StepWizard.Step num="{2}" let:nextStep>
            <div class="grid grid-cols-1 px-4 pt-4">
                <div class="flex col-start-2" style="text-align: end">
                    <button disabled={$data?.descrizione === ''} type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep()}">
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
                    </button>
                </div>
            </div>
            <div class="flex flex-col items-center justify-center">
                <div class="mb-4 text-center">
                    <h2 class="text-lg font-semibold">{$_('page.query.detail.companyLocationSelectionQuery')}</h2>
                </div>

                <FormField>
                    <Radio bind:group={tableVisualization} value={true} touch />
                    <span slot="label">{$_('page.query.detail.table')}</span>
                </FormField>
                <FormField>
                    <Radio bind:group={tableVisualization} value={false} touch />
                    <span slot="label">{$_('page.query.detail.map')}</span>
                </FormField>
            </div>
        </StepWizard.Step>
        <StepWizard.Step num="{3}" let:previousStep let:nextStep>
            <div class="grid grid-cols-2 p-4">
                <div class="justify-self-start col-start-1">
                    <button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
                    </button>
                </div>
                <div class="justify-self-end col-start-2">
                    <button {disabled} type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{() => { [data, loading, error] = Query.save({ id: $data.id, descrizione: $data.descrizione, areaId: $data.areaId, sedi: sediSelected }, () => nextStep()); }}">
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
                    </button>
                </div>
            </div>
            {#if $loadingAziendeEnti || $loading}
                <TableLoading />
            {:else}
                <div class="text-start pb-4 pl-4">
                    <Button
                        on:click="{() => {
                            tableVisualization = !tableVisualization;
                        }}"
                        type="button"
                        variant="raised"
                        class="mt-3.5 w-max p-2.5 text-base"
                    >
                        <Label class="text-sm">{tableVisualization ? $_('page.query.detail.mapView') : $_('page.query.detail.tableView')}</Label>
                    </Button>
                </div>
                {#if tableVisualization}
                    <QuerySedeList data={dataAziendeEnti} {filters}/>
                {:else}
                    <QuerySedeMap data={dataAziendeEnti} />
                {/if}
            {/if}
        </StepWizard.Step>
        <StepWizard.Step num="{4}" let:previousStep>
            <div class="grid grid-cols-2 px-4 pt-4">
                <div class="justify-self-start col-start-1">
                    <button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
                        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
                    </button>
                </div>
                <div class="justify-self-end flex col-start-2">
                    <button title="{$_('page.locations.list.export')}" type="button" class="btn-icon btn-white h-14 w-14 sm:h-16 sm:w-16 mr-2" on:click="{() => Sede.export({ sediId: sediSelected.map(sede => sede.id)})}">
                        <div class="icon-container">
                            <span class="material-icons-outlined main-icon">apartment</span>
                            <span class="material-icons-outlined download-icon">file_download</span>
                        </div>
                    </button>
                    <button title="{$_('page.pscl.list.export')}" type="button" class="btn-icon btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{handlePSCLExport}">
                        <div class="icon-container">
                            <span class="material-icons-outlined main-icon">table_chart</span>
                            <span class="material-icons-outlined download-icon">file_download</span>
                        </div>
                    </button>
                    
                </div>
            </div>
            {#if $psclExportLoading}
                <div class="p-4">
                    <LinearProgress indeterminate />
                </div>
            {/if}
            <QueryReportsContainer data={dataAziendeEnti} {sediSelected}/>
        </StepWizard.Step>
    </StepWizard>
</Card>
